import axios from 'axios';
import Dropzone from 'dropzone';
import Vue from 'vue';
import i18n from './lang';
import { isWindows } from './common/helpers';

// initialize dropzone modal
(window as any).Dropzone = Dropzone;
Dropzone.autoDiscover = false;

const reLogin = () => {
  if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
    const { pathname, search } = location;
    const url = `/login${pathname}${search}`;
    location.href = url;
  } else {
    location.reload();
  }
};

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      reLogin();
    }
    return Promise.reject(error);
  }
);

// override $t because of [[ ]] -> {{ }} replacement
Vue.prototype.$t = function (path: string, args) {
  const translation = i18n.t(path, args).toString();
  return translation.replace(/\[\[/g, '{{').replace(/\]\]/g, '}}');
};

if (isWindows(navigator)) {
  window.document.documentElement.classList.add('windows');
}
